module.exports = __webpack_public_path__ + "img/disagree-active.8fef85f6.gif";